import { render, staticRenderFns } from "./UserRemoveAuthorizationModal.vue?vue&type=template&id=2fc6ea2c&scoped=true&"
import script from "./UserRemoveAuthorizationModal.vue?vue&type=script&lang=js&"
export * from "./UserRemoveAuthorizationModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRemoveAuthorizationModal.vue?vue&type=style&index=0&id=2fc6ea2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6ea2c",
  null
  
)

export default component.exports